import { ApiTags, rootApi } from "../../../services/rootApi";
import { IFeedback } from "./FeedbackForm";


const TAG = ApiTags.Service;
const getTags = (entities: IFeedback[]) => [...entities.map((p) => ({ type: TAG, id: p.id })), TAG]

const feedbackApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getService: builder.query<IFeedback, string>({
      query: (serviceId) => `/feedbacks/${serviceId}`,
      providesTags: (result) => result ? [{ type: TAG, id: result.id }] : [TAG]
    }),
     
    getContactFeedbacks: builder.query<IFeedback[], string>({
      query: (contactId) => {
        return `/FeedbackForms/FeedbackForm(${contactId})`;
      },
      providesTags: (result) => result ? getTags(result) : [TAG]
    }),
  })
})

export const {
  useGetContactFeedbacksQuery,
  useLazyGetContactFeedbacksQuery
} = feedbackApi;